<template>
  <div class="producer-info">
    <div class="wrapper">
      <h1 id="producer-name">{{ searchResult.name }}</h1>
      <h6 class="label">{{ $t("producer") }}</h6>
    </div>
    <div class="heading town-heading">{{ $t("location") }}</div>
    <div class="wrapper">
      <h2 class="town-name" @click="navigateToMap(searchResult)">{{searchResult.town.name }}</h2>
      <div class="label municipality-name">{{ searchResult.municipality.name }}</div>
    </div>
    <img class="map-marker" src="@/assets/images/map-marker.svg" />
    <div class="state">
      <span class="heading" id="state-heading">{{ $t("state") }}</span>
      <span class="state-name">{{ searchResult.state.name }}</span>
    </div>
    <div class="region" v-if="searchResult.municipality.region">
      <span class="heading" id="region-heading">{{ $t("region") }}</span>
      <span class="region-name">{{ searchResult.municipality.region }}</span>
    </div>
    <div class="technique">
      <div class="info-icon">
        <StillIcon :still="searchResult.still" />
        <span class="still-type">{{ searchResult.still.name }}, {{ searchResult.distillations }}x {{ $t("distillation") }}</span>
      </div>
      <div class="info-icon">
        <FermenterIcon :fermenter="searchResult.fermenter" />
        <span class="fermenter-type" v-if="this.$i18n.i18next.language === 'es'">Tinas de {{ searchResult.fermenter.name }}</span>
        <span class="fermenter-type" v-if="this.$i18n.i18next.language === 'en'">{{ searchResult.fermenter.name }} fermenters</span>
      </div>

    </div>
    <div class="heading">{{ $t("associatedBrands") }}</div>
    <div v-for="brand in correspondingNames" v-bind:key="brand.id" @click="navigateToBrand(brand)">
      <div class="brands-list">{{ brand.name }}</div>
      <img class="link-arrow" src="@/assets/images/arrow-right.svg" />
    </div>
    <div v-if="sameTownProducers[0]" class="same-town">
      <span @click="onCarrotClick" id="same-town-label">{{ $t("otherProducers") }}<i>{{searchResult.town.name}}, {{searchResult.state.name}}</i></span>
      <img @click="onCarrotClick" :class="{ expanded: sameTownExpanded }" id="same-town-arrow" src="@/assets/images/arrow.svg" />
      <div 
        id="same-town-results" 
        v-for="sameTownProducer in sameTownProducers" 
        v-bind:key="sameTownProducer.id" 
        @click="navigateToBrand(sameTownProducer)" 
        :class="{ expanded: sameTownExpanded }"  >
        <span class="same-town-producer">{{sameTownProducer.name}}</span>
        <img class="link-arrow" src="@/assets/images/arrow-right.svg" />
      </div>
    </div>
    <div v-if="!sameTownProducers[0]" class="same-town">{{shortenedProducerName}}{{ $t("onlyProducerListed") }}<i>{{searchResult.town.name}}, {{searchResult.state.name}}</i></div>
  </div>
</template>

<script>

import StillIcon from "@/components/StillIcon.vue"
import FermenterIcon from "@/components/FermenterIcon.vue"

export default {
  name: 'ProducerInfo',
  components: {
    StillIcon,
    FermenterIcon
  },
  computed: {
    shortenedProducerName: function () {
      return this.searchResult.name.substr(0, this.searchResult.name.indexOf(' '));
    }
  },
  props: {
    searchResult: Object,
    correspondingNames: Array,
    sameTownProducers: Array,
  },
  data(){
    return {
      sameTownExpanded: false,
    }
  },
  methods: {
    navigateToBrand(clickedLink){
      this.$emit("searchSelected", clickedLink);
      this.sameTownExpanded = false;
      window.scrollTo(0,0);
    },
    navigateToMap(producer){
      this.$store.commit("changeCurrentTown", producer.town)
      this.$router.push('Maps');
    },
    onCarrotClick(){
      this.sameTownExpanded = !this.sameTownExpanded;
    }
  },
  watch: {
    searchResult(newValue){
      this.sameTownExpanded = false;

    }
  }
}
</script>

<style lang="scss" scoped>


h1 {
  font-size: 28px;
  margin-top: 20px;
  margin-bottom: 0;
}

h2 {
  font-size: 24px;
}

div {
  font-family: 'avenir'
}

.heading {
  font-size: 18px;
  font-weight: 100;
  margin-top: 10px;
}

.wrapper {
    display: inline-block;
}

.label {
  margin-top: -5px;
  margin-bottom: 10px;
  float: right;
  font-size: 14px;
  color: grey;
}

.municipality-name {
  margin-top: -10px;
}

.town-name {
  font-size: 28px;
  font-weight: 400;
}

.state {
  margin-top: 5px;
}

.region {
  margin-top: -5px;
}

.region-name {
  margin-left: 8px;
}

.map-marker {
  height: 12px;
  width: 12px;
  margin-left: 3px;
  margin-bottom: 8px
}

.technique {
  margin-top: 15px;
  margin-bottom: 20px;
  line-height: 1.7;
}

.still-type {
  display: inline-block;
  margin-left: 7px;
}

.fermenter-type {
  display: inline-block;
  margin-left: 8px;
}

.state-name, .brands-list, .same-town-producer {
  font-size: 24px;
  font-weight: 400;
  margin-left: 22px;
}

.brands-list {
  display: inline-block;
  margin-top: 2px;
}

.link-arrow {
  height: 12px;
  margin-left: 5px;
  margin-bottom: 8px
}

.town-name:hover, .town-name:active, .brands-list:hover, .brands-list:active {
  color: grey;
}

.info-icon {
  display: flex;
  margin-bottom: 3px;
}

.same-town-producer {
  margin-left: 10px;
}

.same-town {
  margin-top: 15px;
}

#same-town-label {
  font-size: 14px;
}

#same-town-results {
  max-height: 0;
  transition: all 0.25s ease-in-out;
  overflow: hidden;
}

#same-town-results.expanded {
  max-height: 2000px;
}

#same-town-arrow {
  height: 12px;
  width: 12px;
  margin-left: 5px;
  transition: .15s;
}

#same-town-arrow.expanded {
  transform:rotate(90deg);
}


</style>
